module.exports = __webpack_public_path__ + "img/1.a9a12f1e.png";